import { Component, OnInit, ViewChild } from "@angular/core";
import {
  NbDialogRef,
  NbDialogService,
  NbGlobalPhysicalPosition,
  NbToastrService,
} from "@nebular/theme";
import { DataService } from "../../../../@core/utils/data.service";
import {
  CallVm,
  ExportLogCommands,
  Page,
  TraceLogClient,
} from "../../../../System-api";
import { LogListComponent } from "./log-list/log-list.component";
import { ConfirmDialogComponent } from "../../../../shared/confirm-dialog/confirm-dialog.component";
import { NgSelectComponent } from "@ng-select/ng-select";
import { debounceTime, Subject } from "rxjs";

@Component({
  selector: "log-modal",
  templateUrl: "log-modal.component.html",
  styleUrls: ["./log-modal.component.scss"],
})
export class LogModalComponent implements OnInit {
  @ViewChild(LogListComponent, { static: true })
  myChild: LogListComponent;
  @ViewChild("callIdSelect") callIdSelect: NgSelectComponent;
  logList: any;
  currentCallId: any;
  callIdList: any;
  phoneNumberList: any;
  fromNumberList: any[] = [];
  toNumberList: any[] = [];
  selectedFromNumber: any;
  selectedToNumber: any;
  selectedCallId: any;
  page: Page = new Page();
  rows = [];
  loading = false;
  isReadOnly = false;
  callDetail: CallVm;
  disabled: boolean = true;
  isLoading: boolean = false;
  from: "";
  to: "";
  logType: string = "";
  cdrDisabled: boolean = true;
  totalCallIds: number = 0;
  numberOfItemsFromEndBeforeFetchingMore: number = 20;
  pageNumber: number = 0;
  scrollSubject = new Subject<any>();
  searchTermUpdate = new Subject<any>();
  callIdSearchString: string;
  isSearch: boolean = true;
  isSystemClear = false;

  constructor(
    protected ref: NbDialogRef<LogModalComponent>,
    private tracelogClient: TraceLogClient,
    private dataService: DataService,
    private toastrService: NbToastrService,
    private dialogService: NbDialogService
  ) {
    this.page.pageNumber = 0;
    this.page.size = Math.floor((window.innerHeight * 0.55) / Number(34));
    this.page.sortBy = "id";
    this.searchTermUpdate.pipe(debounceTime(1000)).subscribe((searchTerm) => {
      let search = searchTerm.term || "";
      if (searchTerm?.term) {
        if (this.callIdSearchString != search) {
          this.callIdSearchString = searchTerm.term;
          this.isSearch = true;
          this.updateCallId();
        }
      }
    });
    this.scrollSubject.pipe(debounceTime(300)).subscribe(() => {
      this.onScrollToEnd();
    });
  }
  ngOnInit() {
    this.getCallId();
    //this.getPhoneNumberList();
  }
  getCallId() {
    this.tracelogClient
      .getAllCallId(
        this.dataService.CallFlow.id,
        this.numberOfItemsFromEndBeforeFetchingMore,
        this.pageNumber,
        this.callIdSearchString
      )
      .subscribe((rs) => {
        this.callIdList = [...rs.callId];
        this.callIdList.unshift({ callId: "All Log" });
        this.currentCallId = rs.callId[0]?.callId;
        if (this.currentCallId) {
          this.myChild.callId = this.currentCallId;
          this.getLog();
        }
      });
  }
  updateLoading(value: boolean) {
    this.isLoading = value;
  }
  export() {
    this.myChild.exportLog();
  }
  dataLogExport(event) {
    if (event.length > 0) {
      let data = new ExportLogCommands();
      //variable name file
      let callID = event
        .find((f) => f.callId.trim())
        ?.callId?.replaceAll(".", "_");
      let type = event.find((f) => f.type.trim())?.type;
      let fromNumber = event.find((f) => f.fromNumber.trim())?.fromNumber;
      let toNumber = event.find((f) => f.toNumber.trim())?.toNumber;
      //null value
      event.forEach((log) => {
        if (!log.fromNumber.trim()) {
          log.fromNumber = "Unknown";
        }
        if (!log.toNumber.trim()) {
          log.toNumber = "Unknown";
        }
      });
      data.callLogList = event;
      data.callLogList.forEach((callLog) => {
        let date = callLog.created;
        var timeZoneOffset = new Date().getTimezoneOffset();
        var hours = timeZoneOffset / 60;
        var now_utc = Date.UTC(
          date.getUTCFullYear(),
          date.getUTCMonth(),
          date.getUTCDate(),
          date.getUTCHours() - hours,
          date.getUTCMinutes(),
          date.getUTCSeconds()
        );
        callLog.created = new Date(now_utc);
      });
      this.tracelogClient.export(data).subscribe((rs) => {
        let file = this.dataURLtoFile("data:application/xlsx;base64," + rs);
        this.downloadData(
          `${callID || "Unknown"}-${fromNumber || "Unknown"}-${
            toNumber || "Unknown"
          }-${type || "Unknown"}.xlsx`,
          file
        );
      });
    }
  }
  dataURLtoFile(dataurl) {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], "", { type: mime });
  }

  downloadData(filenameForDownload: string, data: any) {
    var textUrl = URL.createObjectURL(data);
    var element = document.createElement("a");
    element.setAttribute("href", textUrl);
    element.setAttribute("download", filenameForDownload);
    element.style.display = "none";
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  }
  setDisabledExport(value: boolean) {
    this.disabled = value;
  }

  getLog() {
    if (this.currentCallId != null) {
      if (this.currentCallId === "All Log") {
        this.callIdSearchString = null;
        this.pageNumber = 0;
        this.reloadCallID();
      }
      
      this.myChild.callId = this.currentCallId;
      this.myChild.setPage({ offset: 0 });
    }
  }

  clear() {
    if (this.isReadOnly) return;
    this.dialogService
      .open(ConfirmDialogComponent, {
        autoFocus: false,
        context: {
          question: "Are you sure you want to clear all conversation logs?",
          textYes: "Yes",
          textNo: "Cancel",
          statusYes: "info",
          statusNo: "basic",
        },
      })
      .onClose.subscribe((isConfirm) => {
        if (isConfirm) {
          this.tracelogClient
            .deleteAll(this.dataService.CallFlow.id.toString())
            .subscribe((rs) => {
              this.showToast(
                rs,
                "Clear log successfully",
                "Clear log unsuccessfully"
              );
              if (rs == true) {
                this.removeLogInformation();
                this.currentCallId = "All Log";
                this.callIdList = [{ callId: "All Log" }];
                this.myChild.setPage({ offset: 0 });
                this.reloadCallID();
              }
            });
        }
      });
  }

  dismiss() {
    this.ref.close(false);
  }
  showToast(result, successText, failText) {
    if (result) {
      this.toastrService.show(successText, `Notification`, {
        position: NbGlobalPhysicalPosition.BOTTOM_LEFT,
        status: "success",
      });
    } else {
      this.toastrService.show(failText, `Notification`, {
        position: NbGlobalPhysicalPosition.BOTTOM_LEFT,
        status: "danger",
      });
    }
  }

  // selectedFromNumberChange(event){
  //   this.myChild.fromNumber = event;
  //   this.getLog();
  // };
  // selectedToNumberChange(event){
  //   this.myChild.toNumber = event;
  //   this.getLog();
  // }

  // searchDatatable($event) {
  //   this.myChild.searchDataSearch($event);
  // }
  searchFromNumber($event) {
    this.myChild.searchFromNumber($event);
  }

  clearLog() {
    if (this.isSystemClear) {
      this.isSystemClear = false;
      return;
    }
    this.callIdSearchString = null;
    this.pageNumber = 0;
    this.myChild.callId = "All Log";
    this.reloadCallID();
    this.myChild.setPage({ offset: 0 });
  }

  reloadCallID() {
    this.loading = true;
    this.totalCallIds = 0;
    this.pageNumber = 0;
    this.tracelogClient
      .getAllCallId(
        this.dataService.CallFlow.id,
        this.numberOfItemsFromEndBeforeFetchingMore,
        this.pageNumber,
        this.callIdSearchString
      )
      .subscribe({
        next: (rs) => {
          this.loading = false;
          this.callIdList = [{ callId: "All Log" }, ...rs.callId];
          if (rs.callId?.length !== 0) {
            this.totalCallIds = rs.page?.totalElements || (rs.callId.length + this.numberOfItemsFromEndBeforeFetchingMore);
          }
        },
        error: (rs) => {
          this.loading = false;
        },
      });
  }

  updateLogInformation(data) {
    if (this.currentCallId === "All Log") return this.removeLogInformation();
    const { from, to, logType } = data;
    this.from = from;
    this.to = to;
    this.logType = logType;
    this.cdrDisabled = logType === "Message";
  }

  removeLogInformation() {
    this.from = "";
    this.to = "";
    this.logType = "";
    this.cdrDisabled = true;
  }

  openCDR() {
    if (this.cdrDisabled) {
      window.open(`portal/call/cr/${this.currentCallId}`, "_blank");
    } else {
      window.open(`portal/call/cdr/${this.currentCallId}`, "_blank");
    }
  }
  onScroll(event: any) {
    if (
      this.loading ||
      this.callIdList.length >= this.totalCallIds ||
      (this.callIdSearchString && 
       this.callIdList.length < this.numberOfItemsFromEndBeforeFetchingMore) ||
      (this.callIdList?.length === 1 && this.callIdList[0].callId === "All Log") ||
      !this.callIdList?.length ||
      this.callIdList?.length === 0
    ) {
      return;
    }

    if (
      event.end + this.numberOfItemsFromEndBeforeFetchingMore >=
      this.callIdList.length
    ) {
      this.scrollSubject.next(null);
    }
  }

  onScrollToEnd() {
    if (this.loading) {
      return;
    }
    this.pageNumber++;
    this.updateCallId();
  }
  onSearch(event) {
    if (this.loading) {
      return;
    }
    this.searchTermUpdate.next(event);
  }
  updateCallId() {
    this.loading = true;
    if (this.callIdSearchString == "" && this.isSearch) {
      this.reloadCallID();
    } else {
      // Check if we've already loaded all items
      if (this.callIdList.length >= this.totalCallIds && this.totalCallIds !== 0) {
        this.loading = false;
        return;
      }

      this.tracelogClient
        .getAllCallId(
          this.dataService.CallFlow.id,
          this.numberOfItemsFromEndBeforeFetchingMore,
          this.callIdSearchString != null && this.isSearch
            ? 0
            : this.pageNumber,
          this.callIdSearchString
        )
        .subscribe({
          next: (rs) => {
            if (this.callIdSearchString != null && this.isSearch) {
              this.callIdList = [];
              this.totalCallIds = 0;
              this.isSearch = false;
            }

            if (!this.callIdList.some((item) => item.callId === "All Log")) {
              this.callIdList.unshift({ callId: "All Log" });
            }
            
            // Only update list if we got new items
            if (rs.callId?.length > 0) {
              this.callIdList = [...this.callIdList, ...rs.callId];
              
              // Update total count on first page or search
              if (this.pageNumber === 0 || this.callIdSearchString) {
                this.totalCallIds = rs.page?.totalElements || (rs.callId.length + this.numberOfItemsFromEndBeforeFetchingMore);
              }
            }
            this.loading = false;
          },
          error: (rs) => {
            this.loading = false;
          },
        });
    }
  }
  onDropdownOpen() {
    const currentValue = this.currentCallId;
    this.isSystemClear = true;
    this.callIdSelect.handleClearClick();
    setTimeout(() => {
      this.currentCallId = currentValue;
    }, 0);
  }
}
